import { FilterableQueryParams } from 'models/FilterableQueryParams';

/**
 * Merges partial href params (e.g. from shared SearchField) onto current filters.
 * Keys explicitly set to `undefined` in `partial` are removed so a new search can
 * clear category/keyword/account; keys omitted from `partial` keep values from
 * `active` (e.g. `embed` stays on when the child does not pass it).
 */
export function mergeShopSearchHrefParams(
  active: FilterableQueryParams,
  partial: Partial<FilterableQueryParams>
): FilterableQueryParams {
  const merged: FilterableQueryParams = { ...active };
  (Object.keys(partial) as (keyof FilterableQueryParams)[]).forEach((key) => {
    const value = partial[key];
    if (value === undefined) {
      delete merged[key];
    } else {
      (merged as Record<keyof FilterableQueryParams, unknown>)[key] = value;
    }
  });
  return merged;
}

export function buildHref({
  q,
  category, // Is a path here, e.g. /bekleidung/
  keyword, // Is a path here, e.g. /bekleidung/hosen/
  account, // Is the parameterized account name here, e.g. bioraum_gmbh
  page,
  sort,
  hasValidCertificate,
  embed
}: FilterableQueryParams): {
  pathname: string;
  query: FilterableQueryParams;
} {
  const basePath = '/shops';
  let pathname = account ? `/company/${account}` : basePath;

  let query: FilterableQueryParams = {};
  if (keyword) {
    if (!keyword.startsWith('/')) {
      pathname += '/';
    }

    pathname += keyword;
  } else if (category) {
    if (!category.startsWith('/')) {
      pathname += '/';
    }
    pathname += category;
  }
  if (!pathname.endsWith('/')) {
    pathname += '/';
  }
  if (q) {
    query.q = q;
  }
  if (page && page !== 1) {
    query.page = page;
  }
  if (sort) {
    query.sort = sort;
  }
  if (hasValidCertificate) {
    query.hasValidCertificate = hasValidCertificate;
  }
  if (embed === true) {
    query.embed = true;
  }
  return {
    pathname,
    query
  };
}
